import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

export function isIPhone({ userAgent }: UtilityContext): boolean {
	return ['iPhone'].includes(userAgent.getParsedUserAgent().getDevice().model || '');
}

export function isIPhoneOrIPad({ userAgent }: UtilityContext): boolean {
	return ['iPhone', 'iPad'].includes(userAgent.getParsedUserAgent().getDevice().model || '');
}

export function isAndroidPhone({ userAgent }: UtilityContext): boolean {
	return (
		userAgent.getParsedUserAgent().getDevice().type === 'mobile' &&
		userAgent.getParsedUserAgent().getOS().name === 'Android'
	);
}

/** @knip-ignore */
export function isChrome({ userAgent }: UtilityContext): boolean {
	return userAgent.getParsedUserAgent().getBrowser().name === 'Chrome';
}

/** @knip-ignore */
export function isAndroidChrome(utilityContext: UtilityContext): boolean {
	return isAndroidPhone(utilityContext) && isChrome(utilityContext);
}

/**
 * Chrome on iPhone or iPad. ua-parser-js reports it as "Mobile Chrome" on iOS, the same browser name
 * as Android Chrome, so the OS check is what tells them apart. In-app browsers (e.g. Facebook's) are
 * not Chrome and report a different browser name.
 */
export function isIOSChrome({ userAgent }: UtilityContext): boolean {
	const parsed = userAgent.getParsedUserAgent();
	return parsed.getOS().name === 'iOS' && parsed.getBrowser().name === 'Mobile Chrome';
}

export function isAndroidWebview({ userAgent }: UtilityContext): boolean {
	return userAgent.getParsedUserAgent().getOS().name === 'Android' && userAgent.isWebview;
}

/**
 * Instagram's in-app browser on iPhone or iPad. `userAgent.isWebview` only reports it as the generic
 * `'ios'` webview type, so the `Instagram` token in the raw user agent is what singles it out.
 */
export function isInstagramIOSWebview({ userAgent }: UtilityContext): boolean {
	return userAgent.getParsedUserAgent().getOS().name === 'iOS' && userAgent.getUserAgent().includes('Instagram');
}

export function isSafari({ userAgent }: UtilityContext): boolean {
	return ['Safari', 'Mobile Safari'].includes(userAgent.getParsedUserAgent().getBrowser().name || '');
}

export function isSamsungPhone(utilityContext: UtilityContext): boolean {
	const { userAgent } = utilityContext;
	return isAndroidPhone(utilityContext) && userAgent.getParsedUserAgent().getDevice().vendor === 'Samsung';
}

export function isMobile({ userAgent }: UtilityContext): boolean {
	return ['mobile', 'tablet'].includes(userAgent.getParsedUserAgent().getDevice().type || '');
}
